import { Highlight, themes } from 'prism-react-renderer'
import { CopyButton } from './CopyButton'

export const CodeBlock = ({
	code,
	language,
	showCopyButton = true,
	copyLabel = 'Copy Code',
	copyMessage,
}: {
	code: string
	language: string
	showCopyButton?: boolean
	copyLabel?: string
	copyMessage?: string
}) => (
	<div className="relative">
		<Highlight theme={themes.vsDark} code={code.trim()} language={language}>
			{({ className, style, tokens, getLineProps, getTokenProps }) => (
				<pre
					className="p-4 rounded-md font-mono text-sm overflow-x-auto border dark:border-gray-700"
					style={style}>
					{tokens.map((line, i) => (
						<div key={i} {...getLineProps({ line })}>
							{line.map((token, key) => (
								<span key={key} {...getTokenProps({ token })} />
							))}
						</div>
					))}
				</pre>
			)}
		</Highlight>
		{showCopyButton && (
			<div className="mt-4">
				<CopyButton
					code={code}
					label={copyLabel}
					customMessage={copyMessage}
					className="w-full sm:w-auto"
				/>
			</div>
		)}
	</div>
)